import { AuthProvider } from './helpers/AuthContext';
import PublicRoutes from './routes/public.routes';
import ProtectedRoutes from './routes/protected.routes';
import RouteGuard from './components/RouteGuard';
import Navbar from './components/Navbar';
import VersionBadge from './components/VersionBadge';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './styles/theme.css';
import './styles/authPages.css';
import './styles/onboarding.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RouteGuard />
        <Navbar />
        <PublicRoutes />
        <ProtectedRoutes />
      </AuthProvider>
      <VersionBadge />
    </div>
  );
}

export default App;
